var DispatcherStorage = /** @class */ (function () {
    function DispatcherStorage() {
    }
    Object.defineProperty(DispatcherStorage, "instance", {
        get: function () {
            if (!this._instance) {
                this._instance = new DispatcherStorage();
            }
            return this._instance;
        },
        enumerable: false,
        configurable: true
    });
    DispatcherStorage.init = function (dispatcher) {
        DispatcherStorage.instance.setDispatcher(dispatcher);
    };
    DispatcherStorage.prototype.setDispatcher = function (dispatcher) {
        this.dispatcher = dispatcher;
    };
    return DispatcherStorage;
}());
export { DispatcherStorage };
export var injectDispatcher = function () {
    if (!DispatcherStorage.instance.dispatcher) {
        throw new Error("DispatcherStorage is not initialized");
    }
    return DispatcherStorage.instance.dispatcher;
};
